import { render, staticRenderFns } from "./SmallArrowUp.vue?vue&type=template&id=0d2588b2"
import script from "./SmallArrowUp.vue?vue&type=script&lang=js"
export * from "./SmallArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports